// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const path = require("path-browserify")
const { loadResourcePath } = require("path/middleware")

const onRouteToAnalytics = (location) => loadResourcePath(location)

const getDefaultLaunchedFrom = ({ location }) =>
  path.join(location.pathname, "../../")

export default {
  path: "/library/:resourceSlug/:cohortId(\\d+)/:section/analytics/:pathItemSourceId(\\d+)?/",
  components: {
    primary: require("library/show/components/LibraryResourceContainer")
      .default,
    modal: require("./components/AnalyticsContainer").default
  },
  onEnter: onRouteToAnalytics,
  getDefaultLaunchedFrom
}
